import {IYandexMapContext, YandexMapContext} from 'modules/yandex-map/context';
import {useContext} from 'react';

export const useYandexMapService = (): IYandexMapContext['service'] => {
    const yandexMapContext = useContext(YandexMapContext);

    return yandexMapContext.service;
};
